/**
 * The one rule every "Upgrade to Pro" entry point follows (86bcd9hg3, decision 24).
 * `proPlan` is the shared `auth.user.pro_plan` summary (or a page's `proPlan` prop).
 *
 * - 'upgrade'  — Basic: offer RiskGuard Pro.
 * - 'switch'   — on an earlier plan: offer "Switch to new plan" instead.
 * - 'fix-card' — on Pro but a payment failed: send them to update their card.
 * - null       — on Pro (or not a landlord): no call to action.
 */
export function proCta(proPlan) {
    if (!proPlan) {
        return null
    }

    if (proPlan.state === 'basic') {
        return 'upgrade'
    }

    if (proPlan.state === 'legacy') {
        return 'switch'
    }

    if (proPlan.state === 'pro' && proPlan.has_payment_problem) {
        return 'fix-card'
    }

    return null
}

/**
 * "$199/yr" style label for a tier price (yearly, account-wide Pro).
 */
export function formatYearly(price) {
    return `$${Number(price).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}/yr`
}

/**
 * "$16.58" style label for a tier's monthly equivalent (decision 23: shown per month,
 * billed annually).
 */
export function formatMonthly(amount) {
    return `$${Number(amount).toFixed(2)}`
}
